
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { getOtpAction, handleLoginAction } from "../../actions/authActions";
// import "./Login.css";

// const Login = () => {
//   const [mobile, setMobile] = useState("");
//   const [otp, setOtp] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   // STEP 1 → Get OTP
//   const handleGetOtp = async (e) => {
//     e.preventDefault();

//     if (!mobile.trim()) {
//       alert("Mobile number is required.");
//       return;
//     }

//     setLoading(true);

//     const result = await dispatch(getOtpAction(mobile));

//     setLoading(false);

//     if (result.success) {
//       alert(result.message);
//       setOtpSent(true);
//     } else {
//       alert(result.message);
//     }
//   };

//   // STEP 2 → Verify OTP and Login
//   const handleLogin = async (e) => {
//     e.preventDefault();

//     if (!otp.trim()) {
//       alert("OTP is required.");
//       return;
//     }

//     setLoading(true);

//     const result = await dispatch(handleLoginAction(mobile, otp));

//     setLoading(false);

//     if (result.success) {
//       alert("Login Successful!");

//       switch (result.role) {
//         case "superAdmin":
//           navigate("/superadmin-dashboard");
//           break;
//         case "Admin":
//           navigate("/admin-dashboard");
//           break;
//         case "candidate":
//           navigate("/candidate-dashboard");
//           break;
//         default:
//           navigate("/dashboard");
//       }
//     } else {
//       alert(`Login Failed: ${result.message}`);
//     }
//   };

//   return (
//     <div className="login-container">
//       <div className="login-box">
//         <form onSubmit={otpSent ? handleLogin : handleGetOtp}>
          
//           {/* MOBILE NUMBER */}
//           <div className="input-group">
//             <label htmlFor="mobile">Mobile Number</label>
//             <input
//               type="tel"
//               id="mobile"
//               value={mobile}
//               onChange={(e) => setMobile(e.target.value)}
//               placeholder="Enter your mobile number"
//               required
//               disabled={otpSent}
//             />
//           </div>

//           {/* OTP FIELD (Visible Only After Sending OTP) */}
//           {otpSent && (
//             <div className="input-group">
//               <label htmlFor="otp">OTP</label>
//               <input
//                 type="text"
//                 id="otp"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//                 placeholder="Enter OTP"
//                 required
//               />
//             </div>
//           )}

//           {/* BUTTON */}
//           <button type="submit" className="login-button" disabled={loading}>
//             {loading ? "Processing..." : otpSent ? "Login" : "Get OTP"}
//           </button>

//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getOtpAction, handleLoginAction } from "../../actions/authActions";
import "./Login.css";

const Login = () => {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // STEP 1 → Get OTP
  const handleGetOtp = async (e) => {
    e.preventDefault();

    if (!mobile.trim()) {
      alert("Mobile number is required.");
      return;
    }

    setLoading(true);

    // Dispatch action to send OTP
    const result = await dispatch(getOtpAction(mobile));

    setLoading(false);

    if (result.success) {
      alert(result.message);
      setOtpSent(true);
    } else {
      alert(result.message);
    }
  };

  // STEP 2 → Verify OTP and Login
  const handleLogin = async (e) => {
    e.preventDefault();

    if (!otp.trim()) {
      alert("OTP is required.");
      return;
    }

    setLoading(true);

    // Dispatch action to verify OTP and Login
    const result = await dispatch(handleLoginAction(mobile, otp));

    setLoading(false);

    if (result.success) {
      alert("Login Successful!");

      // =========================================================
      // ✅ CRITICAL UPDATE: Save Role and Token to LocalStorage
      // =========================================================
      
      // Save Token (if your action returns it, otherwise ensure it's saved in action)
      if (result.token) {
        localStorage.setItem("token", result.token);
      }
      
      // Save User ID (Optional, but good for profile fetching)
      if (result.id) {
        localStorage.setItem("id", result.id);
      }

      // ✅ Save ROLE: This fixes the issue of going back to the dashboard from Home
      localStorage.setItem("role", result.role);

      // =========================================================
      // Redirect based on Role
      // =========================================================
      switch (result.role) {
        case "superAdmin":
          navigate("/superadmin-dashboard");
          break;
        case "Admin":
          navigate("/admin-dashboard");
          break;
        case "candidate":
          navigate("/candidate-dashboard");
          break;
        default:
          navigate("/dashboard"); // Fallback for unknown roles
      }
    } else {
      alert(`Login Failed: ${result.message}`);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">Login</h2>
        
        <form onSubmit={otpSent ? handleLogin : handleGetOtp}>
          
          {/* MOBILE NUMBER INPUT */}
          <div className="input-group">
            <label htmlFor="mobile">Mobile Number</label>
            <input
              type="tel"
              id="mobile"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter your mobile number"
              required
              disabled={otpSent} // Disable changing mobile after OTP sent
            />
          </div>

          {/* OTP INPUT (Visible Only After Sending OTP) */}
          {otpSent && (
            <div className="input-group">
              <label htmlFor="otp">OTP</label>
              <input
                type="text"
                id="otp"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP"
                required
              />
            </div>
          )}

          {/* SUBMIT BUTTON */}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Processing..." : otpSent ? "Login" : "Get OTP"}
          </button>

        </form>
      </div>
    </div>
  );
};

export default Login;